import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ConfirmedIcon from '../assets/imgs/confirmed-tick.svg'
import { Button } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const RemovedSkillModal = ({
  handleRemovedSkillModal,
  modalOpen = false,
  description,
}) => {
  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => handleRemovedSkillModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div className="text-center">
            <img src={ConfirmedIcon} alt="" />
            <p className="fs-20 color-primary font-weight-bold mt-3">
              Service Removed
            </p>
            <Button
              fullWidth={true}
              disableElevation
              className="mt-4"
              type="submit"
              id="btn-primary-no-shadow"
              onClick={() => handleRemovedSkillModal(false)}
            >
              Continue
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default RemovedSkillModal
